import {useCallback, useEffect, useState} from 'react'
import {AuthState} from '../common/spotify'
import {Spotify} from '../lib/spotify'

export const useSpotifyAuth = () => {
  const [authState, setAuthState] = useState<AuthState>()

  const getAuthState = useCallback(async () => {
    const auth = await Spotify.getAuthState()
    setAuthState(a => (a?.authenticated !== auth.authenticated ? auth : a))
  }, [])

  useEffect(() => {
    getAuthState()
  }, [getAuthState])

  return [authState, {refresh: getAuthState}] as const
}
